import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/", //首页
        name: "index",
        component: (resolve) => require(['@/views/home/index.vue'], resolve)
    },
    {
        path: "/contract", //平台协议信息
        name: "contract",
        component: (resolve) => require(['@/views/home/contract.vue'], resolve)
    },
    {
        path: "/game", //游戏落地页
        name: "game",
        component: (resolve) => require(['@/views/LandingPage/game.vue'], resolve)
    },
    {
        path: "/app", //APP盒子落地页
        name: "app",
        component: (resolve) => require(['@/views/LandingPage/app.vue'], resolve)
    },
    {
        path: "/wcjq", //王朝崛起007
        name: "wcjq",
        component: (resolve) => require(['@/views/LoadingPageGameS/WangChaoJueQi.vue'], resolve)
    },
    {
        path: "/rxcs", //857热血传说857
        name: "rxcs",
        component: (resolve) => require(['@/views/LoadingPageGameS/ReXueChuanShuo.vue'], resolve)
    },
    {
        path: "/rxcs2", //857热血传说857
        name: "rxcs2",
        component: (resolve) => require(['@/views/LoadingPageGameS/JiFengReXueChuanShuoB.vue'], resolve)
    },
    {
        path: "/rxcs3", //857热血传说857
        name: "rxcs3",
        component: (resolve) => require(['@/views/LoadingPageGameS/JiFengReXueChuanShuoC.vue'], resolve)
    },

    {
        path: "/yw_lhdzy", //游玩-烈火单职业
        name: "yw_lhdzy",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZY.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_a", //游玩-烈火单职业
        name: "yw_lhdzy_a",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZYA.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_b", //游玩-烈火单职业
        name: "yw_lhdzy_b",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZYB.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_c", //游玩-烈火单职业
        name: "yw_lhdzy_c",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZYC.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_d", //游玩-烈火单职业
        name: "yw_lhdzy_d",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZYD.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_e", //游玩-烈火单职业
        name: "yw_lhdzy_e",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZYE.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_f", //游玩-烈火单职业
        name: "yw_lhdzy_f",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZYF.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_1", //游玩-烈火单职业
        name: "yw_lhdzy_1",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZYH.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_2", //游玩-烈火单职业
        name: "yw_lhdzy_2",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZY1002.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_3", //游玩-烈火单职业
        name: "yw_lhdzy_3",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZY1003.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_4", //游玩-烈火单职业
        name: "yw_lhdzy_4",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZY1004.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_5", //游玩-烈火单职业
        name: "yw_lhdzy_5",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZY1005.vue'], resolve)
    },
    {
        path: "/yw_lhdzy_6", //游玩-烈火单职业
        name: "yw_lhdzy_6",
        component: (resolve) => require(['@/views/LoadingPageGameS/YWLieHuoDZY1006.vue'], resolve)
    },
    {
        path: "/gzyw_lhdzy_1", //广州游玩-烈火单职业
        name: "gzyw_lhdzy_1",
        component: (resolve) => require(['@/views/LoadingPageGameS/GZYWLieHuoDZY1001.vue'], resolve)
    },
    {
        path: "/xn_cycq_a", //小柠互娱-蚩尤传奇
        name: "xn_cycq_a",
        component: (resolve) => require(['@/views/LoadingPageGameS/XNCiYouChuanQi.vue'], resolve)
    },
    {
        path: "/jq_zhangji_a", //玖趣-掌机小精灵
        name: "jq_zhangji_a",
        component: (resolve) => require(['@/views/LoadingPageGameS/JQZhangJi.vue'], resolve)
    },
    {
        path: "/jq_rongyao_a", //玖趣-荣耀舰队
        name: "jq_rongyao_a",
        component: (resolve) => require(['@/views/LoadingPageGameS/JQRongYaoJianDui.vue'], resolve)
    },
    {
        path: "/jq_rongyao_b", //玖趣-荣耀舰队
        name: "jq_rongyao_b",
        component: (resolve) => require(['@/views/LoadingPageGameS/JQRongYaoJianDuiB.vue'], resolve)
    },
    {
        path: "/jq_rongyao_c", //玖趣-荣耀舰队
        name: "jq_rongyao_c",
        component: (resolve) => require(['@/views/LoadingPageGameS/JQRongYaoJianDuiC.vue'], resolve)
    },
    {
        path: "/jq_guijian_a", //玖趣-鬼剑豪
        name: "jq_guijian_a",
        component: (resolve) => require(['@/views/LoadingPageGameS/JQGuiJianHao.vue'], resolve)
    },
    {
        path: "/jq_guijian_b", //玖趣-鬼剑豪
        name: "jq_guijian_b",
        component: (resolve) => require(['@/views/LoadingPageGameS/JQGuiJianHaoB.vue'], resolve)
    },
    {
        path: "/jq_guijian_c", //玖趣-鬼剑豪
        name: "jq_guijian_c",
        component: (resolve) => require(['@/views/LoadingPageGameS/JQGuiJianHaoC.vue'], resolve)
    },
    {
        path: "/jq_guijian1004", //玖趣-鬼剑豪
        name: "jq_guijian1004",
        component: (resolve) => require(['@/views/LoadingPageGameS/JQRongYaoJianDui1004.vue'], resolve)
    },
    {
        path: "/jiaoyin", //脚印
        name: "jiaoyin",
        component: (resolve) => require(['@/views/LoadingPageGameS/JiaoYin.vue'], resolve)
    },
    {
        path: "/jy_baye1001", //脚印-霸业末了
        name: "jy_baye1001",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1001.vue'], resolve)
    },
    {
        path: "/jy_baye1002", //脚印-霸业末了
        name: "jy_baye1002",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1002.vue'], resolve)
    },
    {
        path: "/jy_baye1003", //脚印-霸业末了
        name: "jy_baye1003",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1003.vue'], resolve)
    },
    {
        path: "/jy_baye1004", //脚印-霸业末了
        name: "jy_baye1004",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1004.vue'], resolve)
    },
    {
        path: "/jy_baye1005", //脚印-霸业末了
        name: "jy_baye1005",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1005.vue'], resolve)
    },
    {
        path: "/jy_baye1006", //脚印-霸业末了
        name: "jy_baye1006",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1006.vue'], resolve)
    },
    {
        path: "/jy_baye1007", //脚印-霸业末了
        name: "jy_baye1007",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1007.vue'], resolve)
    },
    {
        path: "/jy_baye1008", //脚印-霸业末了
        name: "jy_baye1008",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1008.vue'], resolve)
    },
    {
        path: "/jy_baye1009", //脚印-霸业末了
        name: "jy_baye1009",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1009.vue'], resolve)
    },
    {
        path: "/jy_baye1010", //脚印-霸业末了
        name: "jy_baye1010",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1010.vue'], resolve)
    },
    {
        path: "/jy_baye1011", //脚印-霸业末了
        name: "jy_baye1011",
        component: (resolve) => require(['@/views/LoadingPageGameS/YQBaYe1010.vue'], resolve)
    },
    {
        path: "/md_1011", //漫地
        name: "md_1011",
        component: (resolve) => require(['@/views/LoadingPageGameS/ManDi1001.vue'], resolve)
    },
    {
        path: "/md_1002", //漫地
        name: "md_1002",
        component: (resolve) => require(['@/views/LoadingPageGameS/ManDi1002.vue'], resolve)
    },
    {
        path: "/md_1003", //漫地
        name: "md_1003",
        component: (resolve) => require(['@/views/LoadingPageGameS/ManDi1003.vue'], resolve)
    }
]


let router = new VueRouter({
    // base: '/dist',
    mode: 'history',
    disableDotRule: true,
    routes
})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js